export enum DsFormsTextDefaultValuesEnum {
  NONE = '',
  MAPNAME = '%MAPNAME%',
  MAPCATEGORYNAME = '%MAPCATEGORYNAME%',
  MAPLEVELNAME = '%MAPLEVELNAME%',
  PROJECTNAME = '%PROJECTNAME%',
  USERNAME = '%USERNAME%',
  USERFULLNAME = '%USERFULLNAME%',
  BIMELEMENTNAME = '%BIMELEMENTNAME%',
  BIMOBJECTID = '%BIMOBJECTID%',
  BIMCATEGORYNAME = '%BIMCATEGORYNAME%',
}
